import { Component } from 'react';
import { debounce } from 'lodash-es';

import {
  searchArticle,
  cancelSearchArticle,
  getCollectionById,
} from 'constants/helpCenter';
import { SEARCH, ROOT } from '../../constants';

class SearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      input: this.props.input || '',
      error: '',
      isFetching: false,
      options: [],
    };

    this.debouncedFetchArticles = debounce(this.fetchArticles, 250);
  }

  componentDidMount() {
    if (this.props.input) {
      this.setState({ isFetching: true });
      this.debouncedFetchArticles(this.props.input, this.onFetchSuccess);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.input !== prevProps.input) {
      this.setState({ isFetching: true });
      this.debouncedFetchArticles(this.props.input, this.onFetchSuccess);
    }
  }

  showSearchResults = () => {
    const { input } = this.state;

    this.props.history.push(`${SEARCH}/${input.replace(/%/g, '')}/`);
  };

  handleChange = (input) =>
    this.setState({ input, isFetching: true }, () => {
      if (this.props.input) {
        return;
      }

      this.debouncedFetchArticles(input, this.onFetchSuccess);
    });

  handleEnterKeyPress = () => {
    this.showSearchResults();
  };

  filterPublished = (data = []) => data.filter(({ status }) => status === 'published');

  fetchArticles = (input, onSuccess) =>
    input
      ? searchArticle(input).then(onSuccess, () => {})
      : this.setState({ options: [], isFetching: false });

  onFetchSuccess = ({
    data: {
      articles: { items },
    },
  }) => {
    this.setState({
      options: this.filterPublished(items),
      isFetching: false,
    });
  };

  handleOptionClick = ({ slug, collectionId }) => {
    const { history } = this.props;

    getCollectionById(collectionId).then(({ data: { collection } }) => {
      const collectionSlug = collection.slug.split('icon')[0];

      history.push(`${ROOT}/${collectionSlug}/${slug}`);
    });
  };

  handleInputClear = () => {
    cancelSearchArticle && cancelSearchArticle();
    this.setState({ input: '', isFetching: false });
  };

  render() {
    const { options, isFetching, input } = this.state;

    return this.props.children({
      onChange: this.handleChange,
      onEnterKeyPress: this.handleEnterKeyPress,
      onOptionClick: this.handleOptionClick,
      onInputClear: this.handleInputClear,
      loading: isFetching,
      value: input,
      options,
    });
  }
}

export default SearchForm;
